import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
export function getIFrameSrc(path) {
  const baseUrl = getFullUrl('app');
  const portalId = PortalIdParser.get();
  return `${baseUrl}/marketplace-embed/${portalId}/${path}`;
}